import './AppLoading.css';

/** Public loading state: never mount account hooks before session validation. */
export function AppLoading({
  error = '',
  onRetry,
}: {
  error?: string;
  onRetry: () => void;
}) {
  return (
    <main className="app-loading">
      {error ? (
        <div className="app-loading-status">
          <p role="alert">{error}</p>
          <button type="button" className="primary" onClick={onRetry}>
            Try again
          </button>
        </div>
      ) : (
        <div
          className="app-loading-spinner"
          role="status"
          aria-label="Loading"
        />
      )}
    </main>
  );
}
